import React from 'react'

import { MeetingCreateContainer } from '@/components/containers/standardization/meetings/MeetingCreateContainer'

const CreateMeetingPage: React.FC = () => <MeetingCreateContainer />

export default CreateMeetingPage
